import { render } from "./ControleCobrancasImobiliariasView.vue?vue&type=template&id=01a0dbcf&scoped=true"
import script from "./ControleCobrancasImobiliariasView.vue?vue&type=script&lang=js"
export * from "./ControleCobrancasImobiliariasView.vue?vue&type=script&lang=js"

import "./ControleCobrancasImobiliariasView.vue?vue&type=style&index=0&id=01a0dbcf&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01a0dbcf"]])

export default __exports__